/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaVolontarioDto } from '../../models/selettiva-volontario-dto';

export interface ApiSelettivaSelettivaVolontarioListGet$Params {
    /**
     * id della selettiva per cui caricare i partecipanti
     */
    selettivaId: number;

    /**
     * id della selettiva per cui caricare i partecipanti
     */
    isPartecipante?: boolean;
}

export function apiSelettivaSelettivaVolontarioListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiSelettivaSelettivaVolontarioListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<SelettivaVolontarioDto>>> {
    const rb = new RequestBuilder(rootUrl, apiSelettivaSelettivaVolontarioListGet.PATH, 'get');
    if (params) {
        rb.query('selettivaId', params.selettivaId, {});
        rb.query('isPartecipante', params.isPartecipante, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<SelettivaVolontarioDto>>;
        }),
    );
}

apiSelettivaSelettivaVolontarioListGet.PATH = '/api/selettiva/selettiva-volontario-list';
